import React from 'react';

const Select = ({ children, id, label, layout = 'full' }) => {
    return (
        <div className={`clx-step__select ${layout}`}>
            <label htmlFor={id}>{label}</label>
            {children}
        </div>
    );
};

export default Select;
